import { render, staticRenderFns } from "./DispatcherSidebar.vue?vue&type=template&id=0d2b6cc3&scoped=true&"
import script from "./DispatcherSidebar.vue?vue&type=script&lang=js&"
export * from "./DispatcherSidebar.vue?vue&type=script&lang=js&"
import style0 from "./DispatcherSidebar.vue?vue&type=style&index=0&id=0d2b6cc3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2b6cc3",
  null
  
)

export default component.exports